import styles from './index.module.scss';
import {Modal, Space, Upload} from 'antd';
import {UploadChangeParam, UploadProps} from 'antd/lib/upload/interface';
import React, {useState} from 'react';
import attrAccept from 'rc-upload/es/attr-accept';
import {humanFileSize} from 'Utils/common';
import {LinkButton} from '../../../Buttons/LinkButton';
import {DeleteOutlined} from '@ant-design/icons';
import classNames from 'classnames';

interface UploadAreaProps extends UploadProps {
    size: number;
    tip?: React.ReactNode; // 导入说明
    onSelect(file?: File): void;
}

export default function UploadArea({
    size,
    tip,
    onSelect,
    ...props
}: UploadAreaProps) {
    const [fileName, setFileName] = useState('');
    const fileSize = humanFileSize(size);

    function beforeUpload() {
        return false;
    }

    function onRemove(e: any) {
        e.preventDefault();
        e.stopPropagation();
        setFileName('');
        onSelect(undefined);
    }

    function onChange(info: UploadChangeParam) {
        const file = info.file as any;
        const {accept} = props;

        if (!attrAccept(file as any, accept || '')) {
            Modal.error({content: '不允许上传该类型文件'});
            onSelect(undefined);
            return false;
        }

        if ((file.size || 0) > size) {
            Modal.error({content: `文件大小不能超过${fileSize}`});
            onSelect(undefined);
            return false;
        } else {
            setFileName(file.name);
            onSelect(file);
        }
    }

    return (
        <Upload.Dragger
            className={classNames(styles.root, {[styles.loaded]: !!fileName})}
            maxCount={1}
            showUploadList={false}
            onChange={onChange}
            beforeUpload={beforeUpload}
            {...props}>
            <div className={styles.icon} />

            <div className={styles.text}>
                {fileName && (
                    <Space>
                        <em>{fileName}</em>
                        <LinkButton
                            onClick={onRemove}
                            className={styles.removeBtn}>
                            <DeleteOutlined />
                        </LinkButton>
                    </Space>
                )}

                {!fileName && (
                    <div>
                        <em>点击或将文件拖拽到这里上传</em>&nbsp;
                        （只支持上传单个文件进行导入）
                    </div>
                )}

                {tip || (
                    <div>
                        当前 Excel 导入数量上限为 5 万条，文件大小上限为{' '}
                        {fileSize}
                    </div>
                )}
            </div>
        </Upload.Dragger>
    );
}
